<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-document-checked"></i> {{$t('pages.mtAbnormalDisplay.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container" v-loading="loading">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.mtStd.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.mtStd.export')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels :range-separator="'~'" :start-placeholder="$t('pages.mtStd.dateStartPh')" :end-placeholder="$t('pages.mtStd.dateEndPh')" :picker-options="pickerOptions0" class="mr10" style="width: 280px"></el-date-picker>
                <el-select v-model="query.Field1" :placeholder="$t('pages.mtStd.typePh')" class="handle-type mr10" clearable>
                    <el-option v-for="item in typeArr" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.mtStd.mine')" class="handle-select mr10">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="isDisplayCompanyName ? item.fullName : item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.mtStd.search')}}</el-button>
            </div>
        </div>

        <!-- MT1082-2008 表9 系统工作异常显示（横向标准表样） -->
        <el-table :data="rows" border class="table" id="mytable" header-cell-class-name="table-header" :height="tableHeight">
            <el-table-column type="index" :label="$t('pages.mtStd.index')" width="60" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('pages.mtStd.mine')" min-width="150"></el-table-column>
            <el-table-column prop="count" :label="$t('pages.mtStd.cumCount')" width="100" align="center"></el-table-column>
            <el-table-column prop="cumTime" :label="$t('pages.mtStd.cumTime')" width="120" align="center"></el-table-column>
            <el-table-column v-for="n in dynamicCols" :key="'ev' + n" :label="eventLabel(n)" min-width="220" align="center">
                <template slot-scope="scope">{{ eventText(scope.row, n) }}</template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'mtAbnormalDisplay',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            loading: false,
            tableHeight: window.innerHeight * 0.75,
            isDisplayCompanyName: false,
            balanceArr: [],
            typeArr: [],
            rows: [],
            query: {
                daterange: '',
                Field1: '',
                balanceId: 0
            }
        };
    },
    computed: {
        dynamicCols() {
            var m = 0;
            this.rows.forEach((r) => {
                if (r.events.length > m) m = r.events.length;
            });
            return Math.max(3, m);
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.query.daterange = [start, end];
        this.getBalance();
        this.getTypes();
        this.getData();
    },
    methods: {
        eventLabel(n) {
            return this.$t('pages.mtStd.nth') + n + this.$t('pages.mtStd.nthAfter') + this.$t('pages.mtStd.status') + '\\' + this.$t('pages.mtStd.cumTime') + '\\' + this.$t('pages.mtStd.timeSpan') + '\\' + this.$t('pages.mtStd.remark');
        },
        eventText(row, n) {
            var ev = row.events[n - 1];
            return ev ? ev.text : '--';
        },
        fmtDay(d) {
            if (!d) return '--';
            var dt = new Date(d);
            return isNaN(dt.getTime()) ? '--' : dateFormat.formatDate(dt, 'yyyy-MM-dd hh:mm');
        },
        getData() {
            if (!this.query.daterange) {
                this.$notify.warning(this.$t('pages.mtStd.dateStartPh'));
                return;
            }
            var sd = dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00');
            var ed = dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00');
            if (new Date(sd).getTime() > new Date(ed).getTime()) {
                this.$notify.warning(this.$t('pages.mtStd.rangeError'));
                return;
            }
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.loading = true;
            this.$zybhttp
                .post('DataInquiry/GetEventList', {
                    startDate: new Date(sd),
                    endDate: new Date(ed),
                    // '全部' 不作为类型条件下发
                    Field1: this.query.Field1 === '全部' || this.query.Field1 == null ? '' : this.query.Field1,
                    PageIndex: 1,
                    PageSize: 1000
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.status == 0) {
                        this.buildRows((res.data.data && res.data.data.list) || []);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$notify.error(this.$t('pages.mtStd.fetchError'));
                });
        },
        getTypes() {
            this.$zybhttp
                .post('DataInquiry/GetEventType', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list || [];
                        this.typeArr = [this.$t('pages.mtStd.all')].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => this.$notify.error(this.$t('pages.mtStd.fetchError')));
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.isDisplayCompanyName = res.data.info1 == '是';
                        this.balanceArr = [{
                            id: 0,
                            name: this.$t('pages.mtStd.all'),
                            fullName: this.$t('pages.mtStd.all')
                        }].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => this.$notify.error(this.$t('pages.mtStd.fetchError')));
        },
        balanceName(bid) {
            for (var i = 0; i < this.balanceArr.length; i++) {
                if (this.balanceArr[i].id === bid) {
                    return this.isDisplayCompanyName ? this.balanceArr[i].fullName : this.balanceArr[i].name;
                }
            }
            return '--';
        },
        // 生成标准表9行：煤矿|累计次数|累计时间|第N次状况\累计时间\起止时刻\备注
        buildRows(list) {
            // GetEventList 无煤矿参数，按选中矿在客户端过滤
            var rows = (list || []).slice();
            var hasBid = rows.some((r) => r.balanceId !== undefined && r.balanceId !== null);
            if (this.query.balanceId != 0 && hasBid) {
                rows = rows.filter((r) => r.balanceId === this.query.balanceId);
            }
            rows.sort(SortField('id', 'asc'));
            var nameField = this.isDisplayCompanyName ? 'fullBalanceName' : 'balanceName';
            var groups = [];
            var map = {};
            rows.forEach((r) => {
                var bid = r.balanceId != null ? r.balanceId : '--';
                if (!map[bid]) {
                    map[bid] = {
                        name: r[nameField] || r.balanceName || this.balanceName(bid),
                        knownMins: null,
                        events: []
                    };
                    groups.push(map[bid]);
                }
                var start = r.createDate ? new Date(r.createDate) : null;
                // 恢复时刻字段各版本命名不一，防御性读取
                var endRaw = r.endDate || r.recoverDate || r.recoveryDate || r.endTime;
                var end = endRaw ? new Date(endRaw) : null;
                var okStart = start && !isNaN(start.getTime());
                var okEnd = end && !isNaN(end.getTime());
                var mins = okStart && okEnd ? Math.max(0, Math.round((end.getTime() - start.getTime()) / 60000)) : null;
                if (mins != null) map[bid].knownMins = (map[bid].knownMins || 0) + mins;
                map[bid].events.push({
                    text: this.nz(r.eventType) + '\\' + (mins != null ? this.formatDuration(mins) : '--') + '\\' + (okStart ? this.fmtDay(start) : '--') + '~' + (okEnd ? this.fmtDay(end) : '--') + '\\' + this.nz(r.remark)
                });
            });
            this.rows = groups.map((g) => {
                return {
                    name: g.name,
                    count: g.events.length,
                    cumTime: g.knownMins != null ? this.formatDuration(g.knownMins) : '--',
                    events: g.events
                };
            });
        },
        // 时长：超1小时显示“X小时Y分钟”，否则“Y分钟”
        formatDuration(mins) {
            var h = Math.floor(mins / 60);
            var m = mins % 60;
            var s = '';
            if (h > 0) s += h + this.$t('pages.mtStd.hours');
            if (m > 0 || h === 0) s += m + this.$t('pages.mtStd.minutes');
            return s;
        },
        nz(v) {
            return v === null || v === undefined || v === '' ? '--' : v;
        },
        printlist() {
            var sd = this.query.daterange ? dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd') : '';
            var ed = this.query.daterange ? dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd') : '';
            var props = [{
                    field: 'index',
                    displayName: this.$t('pages.mtStd.index'),
                    columnSize: '4%'
                },
                {
                    field: 'name',
                    displayName: this.$t('pages.mtStd.mine'),
                    columnSize: '10%'
                },
                {
                    field: 'count',
                    displayName: this.$t('pages.mtStd.cumCount'),
                    columnSize: '7%'
                },
                {
                    field: 'cumTime',
                    displayName: this.$t('pages.mtStd.cumTime'),
                    columnSize: '9%'
                }
            ];
            var data = this.rows.map((r, i) => {
                var o = {
                    index: i + 1,
                    name: r.name,
                    count: r.count,
                    cumTime: r.cumTime
                };
                for (var n = 1; n <= this.dynamicCols; n++) {
                    o['ev' + n] = this.eventText(r, n);
                    props.push({
                        field: 'ev' + n,
                        displayName: this.eventLabel(n),
                        columnSize: '18%'
                    });
                }
                return o;
            });
            print({
                printable: data,
                header: `<div style="display: flex;flex-direction: column;text-align: center"><h3>${this.$t('pages.mtAbnormalDisplay.printTitle')}（${sd} ~ ${ed}）</h3></div>`,
                properties: props,
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:left;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.mtAbnormalDisplay.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        }
    }
};
</script>

<style scoped>
.handle-select {
    width: 150px;
}

.handle-type {
    width: 180px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}
</style>
